module.exports = __webpack_public_path__ + "img/GABY.9139135d.png";